import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { DialogueBody } from "../../../../../customer/components";
const ExpertDialogueBody = ({
  classes,
  body,
  children
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.responseListItem} ${classes.backgroundColor}`
  }, body && /*#__PURE__*/React.createElement(DialogueBody, {
    body: body,
    textStyling: classes.bodyText
  }), children);
};
const styles = ({
  palette
}) => ({
  bodyText: {
    color: palette.primary.dark
  },
  responseListItem: {
    display: "flex",
    position: "relative",
    padding: 16,
    flexDirection: "column",
    backgroundColor: palette.info.main,
    boxShadow: "0px 2px 6px -2px rgba(0, 0, 0, 0.06)",
    borderRadius: "20px",
    wordBreak: "break-word"
  }
});
export default withStyles(styles)(ExpertDialogueBody);
ExpertDialogueBody.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
  body: PropTypes.string
};